import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type PostPrivateNoteInput = {
  title: string;
  content: string;
};

export function usePostPrivateNote() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (input: PostPrivateNoteInput) => {
      const { data, error } = await apiClient
        .from('private_notes')
        .insert([{
          title: input.title,
          content: input.content,
          space_id: currentSpace!.id,
        }])
        .select()
        .single();

      if (error) {
        throw error;
      }

      return data;
    },
    onSuccess: () => {
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.list(currentSpace.id) });
      }
    },
  });
}
